var _clipPath, _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOGuy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 510 510",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2347,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard6",
    transform: "matrix(1,0,0,1.03126,-0.859863,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2347.86,
    y: 0,
    width: 509.38,
    height: 493.958,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2347.86,
    y: 0,
    width: 509.38,
    height: 493.958
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.969687,-334.53,2297.99)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2683.25,
    y: -2369.51,
    width: 509.38,
    height: 488.958,
    style: {
      fill: "rgb(255,197,82)",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3198.46,-2375.35L2677.42,-2375.35L2677.42,-1874.72L3198.46,-1874.72L3198.46,-2375.35ZM3192.63,-2369.51L2683.25,-2369.51L2683.25,-1880.55L3192.63,-1880.55L3192.63,-2369.51Z",
    style: {
      fillOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.06198,0,0,1.02979,-624.929,2479.18)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(769.893,0,0,761.793,2817.03,-1983.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.545,-0.241C0.545,-0.202 0.539,-0.166 0.527,-0.135C0.515,-0.103 0.498,-0.076 0.476,-0.054C0.453,-0.032 0.426,-0.015 0.395,-0.003C0.364,0.009 0.329,0.015 0.29,0.015C0.251,0.015 0.216,0.009 0.185,-0.003C0.153,-0.014 0.126,-0.031 0.104,-0.053C0.081,-0.075 0.064,-0.102 0.052,-0.134C0.04,-0.165 0.034,-0.201 0.034,-0.241C0.034,-0.28 0.04,-0.315 0.053,-0.347C0.065,-0.378 0.082,-0.405 0.105,-0.427C0.127,-0.449 0.154,-0.466 0.186,-0.478C0.217,-0.49 0.252,-0.496 0.29,-0.496C0.328,-0.496 0.363,-0.49 0.394,-0.478C0.425,-0.466 0.452,-0.449 0.475,-0.427C0.497,-0.404 0.514,-0.377 0.527,-0.346C0.539,-0.315 0.545,-0.28 0.545,-0.241ZM0.29,-0.376C0.259,-0.376 0.234,-0.364 0.217,-0.341C0.2,-0.318 0.191,-0.284 0.191,-0.241C0.191,-0.196 0.2,-0.163 0.217,-0.14C0.234,-0.117 0.258,-0.105 0.29,-0.105C0.322,-0.105 0.347,-0.117 0.364,-0.14C0.381,-0.163 0.389,-0.197 0.389,-0.241C0.389,-0.284 0.38,-0.317 0.363,-0.341C0.346,-0.364 0.321,-0.376 0.29,-0.376Z",
    style: {
      fill: "rgb(107,252,178)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.679828,0,0,0.679828,3761.32,-3105.83)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.709386,0,0,0.709386,7.08472,738.28)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1330.98,
    cy: 863.719,
    r: 92.999,
    style: {
      fill: "white"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1330.98,750.382C1393.53,750.382 1444.32,801.167 1444.32,863.719C1444.32,926.272 1393.53,977.057 1330.98,977.057C1268.42,977.057 1217.64,926.272 1217.64,863.719C1217.64,801.167 1268.42,750.382 1330.98,750.382ZM1330.98,770.721C1382.3,770.721 1423.98,812.392 1423.98,863.719C1423.98,915.047 1382.3,956.718 1330.98,956.718C1279.65,956.718 1237.98,915.047 1237.98,863.719C1237.98,812.392 1279.65,770.721 1330.98,770.721Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.322543,0,0,0.322543,541.889,1056.84)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1330.98,
    cy: 863.719,
    r: 92.999
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.679828,0,0,0.679828,3611.89,-3105.83)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.709386,0,0,0.709386,7.08472,738.28)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1330.98,
    cy: 863.719,
    r: 92.999,
    style: {
      fill: "white"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1330.98,750.382C1393.53,750.382 1444.32,801.167 1444.32,863.719C1444.32,926.272 1393.53,977.057 1330.98,977.057C1268.42,977.057 1217.64,926.272 1217.64,863.719C1217.64,801.167 1268.42,750.382 1330.98,750.382ZM1330.98,770.721C1382.3,770.721 1423.98,812.392 1423.98,863.719C1423.98,915.047 1382.3,956.718 1330.98,956.718C1279.65,956.718 1237.98,915.047 1237.98,863.719C1237.98,812.392 1279.65,770.721 1330.98,770.721Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.322543,0,0,0.322543,541.889,1056.84)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1330.98,
    cy: 863.719,
    r: 92.999
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOGuy);
export default __webpack_public_path__ + "static/media/o_guy.89332f7004554d6ceae4d8ebda713638.svg";
export { ForwardRef as ReactComponent };